{
    "api_keys": {
        "label": "e.g. Production - my integration",
        "companies": "Select companies"
    },
    "work_email": "name@company.com",
    "billing_name": "Eg. your company name",
    "password": "Enter password",
    "confirmPassword": "Enter the same password again",
    "new_password": "Enter new password",
    "confirm_new_password": "Enter the same password again",
    "comment": "Comment...",
    "request": {
        "item_name": "Enter item",
        "total_price": "0,00",
        "quantity": "0",
        "description": "We need this to build space rockets.",
        "subscription_name": "My new subscription",
        "subscription_price": "0,00",
        "link": "http://www.domain.com/",
        "date": "MM/DD/YYYY",
        "date_format": {
            "month_year": "MM/YYYY"
        },
        "reject": "Reason for rejection",
        "request_changes": "What changes are you requesting?",
        "invoiceNumber": "Invoice Number",
        "mileage": {
            "select_a_vehicle": "Select a vehicle",
            "distance": "Enter trip distance",
            "start_address": "Enter the start address",
            "destination_address": "Enter the destination address",
            "reason": "Enter the reason for the trip",
            "additional_stop": "Enter an additional stop address",
            "additional_distance_reason": "Traffic jam"
        },
        "hospitality": {
            "reason": "Release party",
            "merchant": "Restaurant \"Delicious\"",
            "attendees": "Write an attendee's name and press enter to add"
        },
        "folder": {
            "destination": "Vienna",
            "folder_name": "#1 - 01.04.2022 - 12.4.2022 - Vienna"
        },
        "material_code": "Item Code"
    },
    "vendor": {
        "company_name": "E.g. Amazon",
        "description": "E.g. why you choose this vendor",
        "street_name": "Maxwell street",
        "street_number": "31",
        "zip": "80335",
        "city": "Munich",
        "country": "Germany",
        "country_code": "Germany (DE)",
        "contact_person_name": "Greta Mustermann",
        "contact_person_email": "greta.mustermann@vendor.com",
        "contact_person_phone": "+49 1575 7112363",
        "tax_number": "340291847",
        "vat_number": "BG999999999",
        "bic": "BARCGB22XXX",
        "account_number": "31510604",
        "sort_code": "100000",
        "creditor_number": "70001",
        "select_a_vendor": "Select a vendor"
    },
    "employee": {
        "first_name": "Max",
        "last_name": "Mustermann",
        "email": "max.mustermann@finway.de",
        "location": "Munich",
        "work_phone": "+49151666666",
        "limit": "Enter limit",
        "position": "Software engineer",
        "creditor_number": "95001",
        "mileage_rate": "30 Cents"
    },
    "employee_absence": {
        "start_date": "DD/MM/YY",
        "end_date": "DD/MM/YY"
    },
    "cost_center": {
        "name": "E.g. Marketing",
        "id": "10",
        "bic": "BARCGB22XXX",
        "budget_value": "200",
        "select_a_cost_center": "Select a cost center"
    },
    "bug_report_message": "Please share your feedback with us or report a bug.",
    "icon_search": "E.g. Amazon",
    "company_settings": {
        "name": "Finway GmbH",
        "companyIdentifier": "1234",
        "iban": "DE89 3704 0044 0532 0130 00",
        "bic": "BARCGB22XXX",
        "default_creditor_number": "70000",
        "default_employee_creditor_number": "95000",
        "address_line": "444 Saratoga Ave",
        "city": "Santa Clara",
        "country": "US",
        "zip": "94430",
        "distance_buffer": "30"
    },
    "banking": {
        "search_term": "Bank code, bank name or similar"
    },
    "expense_account": {
        "account_name": "Marketing costs",
        "account_code": "6600",
        "select_an_expense_account": "Select an expense account"
    },
    "cost_center_2": {
        "name": "Product A",
        "code": "100",
        "select_a_cost_center_2": "Select a cost center 2"
    },
    "filter_form": {
        "min_amount": "10",
        "max_amount": "100",
        "min_date": "MM/DD/YYYY",
        "max_date": "MM/DD/YYYY",
        "iban": "DE89 3704 0044 0532 0130 00",
        "min_probability": "0",
        "max_probability": "100",
        "due_in_days": 0
    },
    "expense_filter": {
        "min_amount": "10",
        "max_amount": "100",
        "min_date": "MM/DD/YYYY",
        "max_date": "MM/DD/YYYY"
    },
    "inbox_filter": {
        "min_upload_date": "MM/DD/YYYY",
        "max_upload_date": "MM/DD/YYYY"
    },
    "matching": {
        "expense_id": "Expense ID",
        "min_date": "MM/DD/YYYY",
        "max_date": "MM/DD/YYYY"
    },
    "export": {
        "date": "MM/DD/YYYY"
    },
    "search": "Search",
    "wallet": {
        "beneficiary_name": "Hans Zimmer",
        "beneficiary_address": "Am Oberwiesenfeld 19, 80809 München",
        "bank_name": "Deutsche Bank",
        "bank_address": "Marienplatz 21, 80331 München",
        "bank_country": "Germany",
        "bank_country_code": "DE",
        "verification_code": "Enter verification code",
        "description": "Transfer"
    },
    "tax": {
        "tax_rate": "19",
        "bu_code": "9",
        "bu_code_name": "Trade payables & other liabilities"
    },
    "team": {
        "team_name": "Finance"
    },
    "transaction": {
        "transaction_category": "Select category"
    },
    "workflow": {
        "name": "Your workflow name",
        "request_type": "Please select which type of request should trigger this workflow"
    },
    "start_date": "Start date",
    "end_date": "End date",
    "liquidity": {
        "scenario_name": "Scenario name",
        "select_a_scenario": "Select a scenario",
        "transaction_title": "Rent"
    },
    "role_name": "Bookkeeper",
    "csv_settings": {
        "new_template_name": "My Template"
    },
    "sso": {
        "tenant_domain": "your-tenant-domain.com",
        "client_id": "Your client ID",
        "client_secret": "Your client secret"
    },
    "personio": {
        "client_id": "Your client ID",
        "client_secret": "Your client secret",
        "email": "Enter email"
    },
    "datev_csv_config": {
        "wallet_account": "3610",
        "cash_transit_account": "1460",
        "account_number_length": "4"
    },
    "datev_client_and_consultant_number": {
        "client_number": "99999",
        "consultant_number": "713111"
    }
}
